import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Flex } from '@costar/theme-ui';
import React from 'react';

var _excluded = ["children"];
var Filterbar = function Filterbar(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'xl' : _props$gap,
    _props$bg = props.bg,
    bg = _props$bg === void 0 ? 'neutral.lighter' : _props$bg,
    _props$height = props.height,
    height = _props$height === void 0 ? '48px' : _props$height;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Flex, _extends({
    px: "md" //aligning with current suite padding | Cosmos 2.0 = xxl
    ,
    py: "xs-2",
    gap: gap,
    bg: bg,
    height: height,
    alignItems: "center",
    overflow: "hidden",
    justifyContent: "end",
    borderBottom: "neutral.medium",
    flex: "1"
  }, props), children);
};

export default Filterbar;
//# sourceMappingURL=filterbar.esm.js.map
